import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Button, FavoriteButton, ShareButton } from "@/components/Buttons";
import ChannelLinearEpisodesSlider from "@/components/ChannelLinearEpisodesSlider";
import ChatDisplay from "@/components/Chat/ChatDisplay";
import ExpandText from "@/components/ExpandText";
import Loading from "@/components/Loading";
import WatchMetaTags from "@/components/MetaTags/WatchMetaTags";
import Palette from "@/components/Palette";
import StreaksPlayer from "@/components/Player/StreaksPlayer";
import WatchRecommend from "@/components/Rtoaster/WatchRecommend";
import TvShowEpisodesSlider from "@/components/TvShowEpisodesSlider";
import WatchThumbnail from "@/components/WatchThumbnail";
import { useAuthUserQuery, useBreadcrumbs, useCopyrights, useDeviceInfoQuery, usePlayerEventHandler, usePrepareToPlay, usePrevious, useUnSubscribedStatusLazyQuery, useWatchQuery, useModal } from "@/hooks";
import config, { getStoreId } from "@/lib/config";
import dayjs from "@/lib/day";
import { checkFullScreen } from "@/lib/playerUtils";
import routes from "@/lib/routes";
import styles from "@/styles/Watch.module.scss";
import classnames from "classnames";
import { useRouter } from "next/router";
import Link from "next/link";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
var ChatDisplayIcon = function ChatDisplayIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: "129",
      height: "43",
      x: "0.5",
      rx: "21.5",
      fill: "#2A2E33"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32.3568 28.5613L31.9052 29.3246C31.5027 30.0046 30.4968 30.0046 30.0935 29.3246L29.6418 28.5613C29.2918 27.9696 29.1168 27.673 28.8352 27.5096C28.5535 27.3455 28.1993 27.3396 27.491 27.3271C26.4443 27.3096 25.7885 27.2455 25.2385 27.0171C24.733 26.8077 24.2737 26.5008 23.8867 26.1139C23.4998 25.727 23.1929 25.2677 22.9835 24.7621C22.666 23.9971 22.666 23.0263 22.666 21.0846V20.2513C22.666 17.5238 22.666 16.1596 23.2802 15.158C23.6236 14.5973 24.0947 14.1258 24.6552 13.7821C25.6577 13.168 27.0227 13.168 29.7493 13.168H32.2493C34.9768 13.168 36.341 13.168 37.3435 13.7821C37.9039 14.1256 38.375 14.5968 38.7185 15.1571C39.3327 16.1596 39.3327 17.5246 39.3327 20.2513V21.0846C39.3327 23.0263 39.3327 23.9971 39.016 24.7621C38.8065 25.2677 38.4995 25.7271 38.1124 26.114C37.7254 26.501 37.2659 26.8078 36.7602 27.0171C36.2102 27.2455 35.5543 27.3088 34.5077 27.3271C33.7993 27.3396 33.4452 27.3455 33.1635 27.5096C32.8818 27.673 32.7068 27.9688 32.3568 28.5613ZM27.666 21.293C27.5003 21.293 27.3413 21.3588 27.2241 21.476C27.1069 21.5932 27.041 21.7522 27.041 21.918C27.041 22.0837 27.1069 22.2427 27.2241 22.3599C27.3413 22.4771 27.5003 22.543 27.666 22.543H32.2493C32.4151 22.543 32.5741 22.4771 32.6913 22.3599C32.8085 22.2427 32.8743 22.0837 32.8743 21.918C32.8743 21.7522 32.8085 21.5932 32.6913 21.476C32.5741 21.3588 32.4151 21.293 32.2493 21.293H27.666ZM27.041 19.0013C27.041 18.8355 27.1069 18.6766 27.2241 18.5594C27.3413 18.4422 27.5003 18.3763 27.666 18.3763H34.3327C34.4984 18.3763 34.6574 18.4422 34.7746 18.5594C34.8918 18.6766 34.9577 18.8355 34.9577 19.0013C34.9577 19.1671 34.8918 19.326 34.7746 19.4432C34.6574 19.5605 34.4984 19.6263 34.3327 19.6263H27.666C27.5003 19.6263 27.3413 19.5605 27.2241 19.4432C27.1069 19.326 27.041 19.1671 27.041 19.0013Z",
      fill: "#FAFAFA"
    }), /*#__PURE__*/_jsx("path", {
      d: "M44.8688 17.82C45.6388 17.84 47.1788 17.83 48.2788 17.67C49.2888 17.52 50.2988 17.3 50.7988 17.06L51.6288 18.16C51.2888 18.25 51.0188 18.32 50.8588 18.36C50.2388 18.52 49.4388 18.65 48.6688 18.76C47.5288 18.92 46.0588 18.96 45.1888 18.98L44.8688 17.82ZM45.2988 24.72C47.0688 23.91 47.8588 22.59 47.8588 20.72C47.8588 20.72 47.8588 20.07 47.8588 18.65L49.1688 18.5C49.1688 19.36 49.1688 20.69 49.1688 20.69C49.1688 22.71 48.5088 24.42 46.5788 25.58L45.2988 24.72ZM44.1188 20.22C44.3988 20.24 44.7288 20.27 45.0488 20.27C45.6788 20.27 51.0288 20.27 51.6988 20.27C51.9088 20.27 52.3788 20.24 52.5988 20.22V21.51C52.3288 21.49 51.9988 21.47 51.7188 21.47C51.0888 21.47 45.6488 21.47 45.0588 21.47C44.7488 21.47 44.3788 21.49 44.1188 21.51V20.22ZM57.3312 18.65C57.3612 18.89 57.4312 19.15 57.4912 19.41C57.8312 20.61 58.7712 24.05 59.0212 24.88C59.0712 25.06 59.2112 25.5 59.2812 25.7L57.9312 26.04C57.8912 25.77 57.8312 25.44 57.7512 25.16C57.5012 24.29 56.5912 20.72 56.2712 19.68C56.2012 19.43 56.0912 19.18 55.9812 18.97L57.3312 18.65ZM62.1312 20.2C61.7012 21.07 60.7012 22.58 60.0012 23.32L58.8912 22.77C59.4112 22.31 60.1012 21.47 60.3712 20.98C59.8512 21.07 55.7812 21.92 54.9612 22.1L54.6512 20.91C54.9612 20.88 55.2412 20.85 55.5712 20.79C56.1112 20.71 60.1112 19.95 60.8212 19.79C60.9912 19.75 61.1912 19.69 61.3212 19.63L62.1312 20.2ZM68.4512 19.07C68.6412 19.49 69.1312 20.8 69.2712 21.26L68.0812 21.67C67.9512 21.19 67.5112 19.98 67.2712 19.46L68.4512 19.07ZM72.1412 19.79C72.0312 20.12 71.9712 20.33 71.9112 20.53C71.6512 21.54 71.2212 22.58 70.5412 23.45C69.6112 24.66 68.3712 25.49 67.2012 25.94L66.1512 24.87C67.2412 24.57 68.6412 23.81 69.4612 22.77C70.1412 21.93 70.6312 20.6 70.7412 19.34L72.1412 19.79ZM66.1312 19.59C66.3812 20.1 66.8712 21.32 67.0612 21.88L65.8412 22.33C65.6812 21.8 65.1712 20.46 64.9312 20.03L66.1312 19.59ZM76.6212 24.05C76.6212 23.28 76.6212 19.14 76.6212 18.3C76.6212 17.94 76.5912 17.45 76.5212 17.09H78.0812C78.0412 17.45 77.9912 17.88 77.9912 18.3C77.9912 19.4 78.0012 23.31 78.0012 24.05C78.0012 24.33 78.0412 25.03 78.0912 25.44H76.5212C76.5912 25.05 76.6212 24.44 76.6212 24.05ZM77.7012 19.68C79.0312 20.05 81.1912 20.84 82.1712 21.32L81.6112 22.71C80.4712 22.12 78.7912 21.48 77.7012 21.12V19.68ZM84.4912 17.17H92.6812V18.19H84.4912V17.17ZM84.9512 18.7H92.2912V19.66H84.9512V18.7ZM84.1212 20.21H93.0012V21.23H84.1212V20.21ZM87.9312 16.51H89.1512V21.07H87.9312V16.51ZM87.9412 20.59L88.9812 21.08C87.9112 22.23 86.1412 23.24 84.5112 23.75C84.3312 23.46 83.9912 23.02 83.7412 22.77C85.3212 22.36 87.0612 21.5 87.9412 20.59ZM89.6712 20.78C90.1912 22.77 91.3012 24.22 93.3612 24.81C93.0912 25.05 92.7512 25.55 92.5812 25.88C90.3412 25.1 89.2312 23.44 88.5812 20.99L89.6712 20.78ZM91.9812 21.38L92.9712 22.13C92.2212 22.67 91.3212 23.22 90.6312 23.56L89.8712 22.92C90.5412 22.53 91.4412 21.89 91.9812 21.38ZM84.8012 24.77C86.0112 24.56 87.8512 24.18 89.5612 23.81L89.6712 24.89C88.1012 25.25 86.4012 25.62 85.1612 25.89L84.8012 24.77ZM86.1712 22.74L86.9612 21.95L87.3712 22.06V24.94H86.1712V22.74ZM98.0212 20.23H99.3412V24.49C99.3412 25.16 99.1912 25.5 98.7312 25.7C98.2612 25.88 97.6012 25.9 96.7212 25.9C96.6712 25.53 96.4812 24.99 96.3012 24.63C96.8712 24.66 97.5812 24.66 97.7712 24.65C97.9612 24.65 98.0212 24.61 98.0212 24.46V20.23ZM95.6212 21.49L96.8812 21.82C96.4312 23.01 95.6912 24.22 94.9812 24.98C94.7312 24.76 94.1812 24.42 93.8712 24.26C94.5912 23.6 95.2512 22.53 95.6212 21.49ZM100.361 21.92L101.491 21.45C102.151 22.38 102.881 23.61 103.151 24.46L101.911 25.01C101.681 24.18 101.001 22.89 100.361 21.92ZM95.1012 17.15H102.191V18.34H95.1012V17.15ZM94.1912 19.56H103.131V20.76H94.1912V19.56Z",
      fill: "#FAFAFA"
    })]
  }));
};
ChatDisplayIcon.defaultProps = {
  viewBox: "0 0 129 43",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { chatEnableErrorCodes, beforeDeliveryStartErrorCode } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function WatchTags(_ref) {
  let {
    meta,
    isBeforeChatEnd,
    isChatAvailableMeta
  } = _ref;
  const filterdTags = [meta.rating !== "G" ? meta.rating : null, meta !== null && meta !== void 0 && meta.genres ? meta.genres.map(g => g.name).join("/") : null, meta.production_year ? `${meta.production_year}年` : null, meta.production_country ? meta.production_country.join(" ") : null, meta.duration ? `${Math.floor(meta.duration / 60)}分` : null, meta.delivery_end_at ? `${meta.delivery_end_at}まで配信` : null].filter(v => v).join("・");
  return /*#__PURE__*/_jsxs("div", {
    className: styles.tags,
    children: [/*#__PURE__*/_jsx("span", {
      children: filterdTags
    }), isBeforeChatEnd && isChatAvailableMeta && /*#__PURE__*/_jsx("span", {
      className: styles.chatLabel,
      children: "\u30C1\u30E3\u30C3\u30C8\u3042\u308A"
    })]
  });
}
export var __N_SSP = true;
export default function Watch() {
  var _router$query, _rooms$, _rooms$2, _playbackAuth$error3, _playbackAuth$error4;
  const playerRef = useRef();
  const {
    setBreadcrumbs
  } = useBreadcrumbs();
  const {
    setCopyrights
  } = useCopyrights();
  const router = useRouter();
  const watchId = useMemo(() => Number(router.query.id), [router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.id]);
  const {
    0: playerReady,
    1: setPlayerReady
  } = useState(false);
  const prevWatchId = usePrevious(watchId);
  const {
    0: prevState,
    1: setPrevState
  } = useState();
  // チャットコンポーネントの有無
  const {
    0: chatEnable,
    1: setChatEnable
  } = useState(false);
  // チャットUI表示の有無
  const {
    0: chatDisplay,
    1: setChatDisplay
  } = useState(false);
  const {
    data,
    loading: userLoading
  } = useAuthUserQuery({
    fetchPolicy: "network-only"
  });
  const user = data === null || data === void 0 ? void 0 : data.user;
  const {
    data: {
      deviceInfo
    } = {}
  } = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  });
  const {
    isAndroid,
    isMobile,
    isTablet
  } = deviceInfo !== null && deviceInfo !== void 0 ? deviceInfo : {};
  const {
    loading: watchLoading,
    data: watch,
    refetch: watchQueryRefetch
  } = useWatchQuery({
    variables: {
      id: watchId
    },
    fetchPolicy: "cache-and-network"
  });
  const {
    episode,
    nextEpisode,
    entitlements,
    howtoPlay
  } = watch || {};
  const loggedIn = !userLoading && (data === null || data === void 0 ? void 0 : data.user);
  const isSVOD = !!howtoPlay.courses[0];
  const [unSubscribedStatus, {
    data: unSubscribedStatusData
  }] = useUnSubscribedStatusLazyQuery();
  const ignoreMetaId = parseInt(episode.id, 10);
  const [prepareToPlay, state] = usePrepareToPlay(episode, entitlements);
  const {
    hideModal
  } = useModal();
  const {
    loading,
    playbackAuth,
    mediaSource,
    rooms
  } = state;
  // チャット情報
  const isChatAvailableMeta = useMemo(() => (rooms === null || rooms === void 0 ? void 0 : rooms.length) > 0 && !isAndroid, [rooms, isAndroid]);
  const encodeStartDate = episode !== null && episode !== void 0 && episode.encode_start_date ? dayjs(episode === null || episode === void 0 ? void 0 : episode.encode_start_date) : null;
  const encodeEndDate = episode !== null && episode !== void 0 && episode.encode_end_date ? dayjs(episode === null || episode === void 0 ? void 0 : episode.encode_end_date) : null;
  const pageEntryTime = useMemo(() => dayjs(), []);
  const isLinearAvailable = !!(episode !== null && episode !== void 0 && episode.source_epg_id) && encodeEndDate && pageEntryTime.isBefore(encodeEndDate);
  const liveStartBefore = (rooms === null || rooms === void 0 ? void 0 : rooms.length) > 0 ? ((_rooms$ = rooms[0]) === null || _rooms$ === void 0 || (_rooms$ = _rooms$.customData) === null || _rooms$ === void 0 ? void 0 : _rooms$.liveStartBefore) || 0 : 0;
  const liveEndAfter = (rooms === null || rooms === void 0 ? void 0 : rooms.length) > 0 ? ((_rooms$2 = rooms[0]) === null || _rooms$2 === void 0 || (_rooms$2 = _rooms$2.customData) === null || _rooms$2 === void 0 ? void 0 : _rooms$2.liveEndAfter) || 0 : 0;
  const chatStartTime = encodeStartDate ? encodeStartDate.subtract(liveStartBefore, "minute") : null;
  const chatEndTime = encodeEndDate ? encodeEndDate.add(liveEndAfter, "minute") : null;
  // チャットの有効期間チェック
  const isValidChatPeriod = useMemo(() => {
    if (!chatStartTime || !chatEndTime) return false;
    const now = dayjs();
    return chatStartTime.isBefore(now) && chatEndTime.isAfter(now);
  }, [chatStartTime, chatEndTime]);
  // ラベル表示用、チャット終了前チェック
  const isBeforeChatEnd = useMemo(() => {
    if (!chatEndTime) return false;
    const now = dayjs();
    return chatEndTime.isAfter(now);
  }, [chatEndTime]);
  const handlePlayerReady = useCallback(player => {
    playerRef.current = player;
    setPlayerReady(true);
  }, []);
  const handleEnded = useCallback(() => {
    if (nextEpisode) {
      state.displayOverlay({
        reason: "next_episode"
      });
    }
  }, [nextEpisode]);
  const setChatDisplayState = useCallback(bool => {
    setChatDisplay(bool);
    if (bool) {
      window.scrollTo({
        top: 0
      });
    }
  }, []);
  const turnOnChatDisplay = useCallback(() => {
    setChatDisplayState(true);
  }, [setChatDisplayState]);
  const playToken = useMemo(() => {
    if (mediaSource && mediaSource !== null && mediaSource !== void 0 && mediaSource.play_token) {
      return mediaSource.play_token;
    } else {
      return null;
    }
  }, [mediaSource]);
  useEffect(() => {
    if (loggedIn && isSVOD) {
      unSubscribedStatus({
        variables: {
          courseId: Number(howtoPlay.courses[0].id)
        }
      });
    }
  }, [loggedIn, isSVOD, data, howtoPlay]);
  useEffect(() => {
    setChatEnable(isChatAvailableMeta);
  }, [isChatAvailableMeta]);
  usePlayerEventHandler(user, userLoading, deviceInfo, playerRef.current, episode, entitlements, playbackAuth, playToken, state.displayOverlay, state.canplay, {
    ended: handleEnded
  });
  useEffect(() => {
    const handler = path => {
      // 遷移先がwatchページの場合はリセット
      if (path.includes("/watch")) {
        setPrevState(state);
        state.reset();
      }
      hideModal();
    };
    router.events.on("routeChangeStart", handler);
    return () => {
      router.events.off("routeChangeStart", handler);
    };
  }, []);

  // パンクズ
  useEffect(() => {
    if (episode) {
      const {
        tvShow,
        channel
      } = episode;
      setCopyrights(episode.copyright);
      const storeId = getStoreId();
      const valuePlanId = config.valuePlanId.vod;
      const channelId = parseInt(channel === null || channel === void 0 ? void 0 : channel.id, 10);
      const breadcrumbs = [{
        text: "ホーム",
        href: routes.home
      }];
      if (channel) {
        if (storeId === channelId) {
          breadcrumbs.push({
            text: "単品商品",
            href: routes.store
          });
        } else if (valuePlanId === channelId) {
          breadcrumbs.push({
            text: config.valuePlan.text,
            href: routes.valuePlan
          });
        } else {
          breadcrumbs.push({
            text: "月額商品一覧",
            href: routes.channels
          });
          breadcrumbs.push({
            text: channel.name,
            href: routes.channelDetail(channel.id)
          });
        }
      }
      if (tvShow) {
        breadcrumbs.push({
          text: tvShow.name,
          href: routes.title(tvShow.id)
        });
      }
      breadcrumbs.push({
        text: episode.name
      });
      setBreadcrumbs(breadcrumbs);
    }
  }, [router, episode]);

  // 配信開始になったらプレイヤー関連をリロードする
  const deliveryCheckIntervalRef = useRef(null);
  const {
    0: isDeliveryStartChecked,
    1: setIsDeliveryStartChecked
  } = useState(false);
  const checkDeliveryStart = useCallback(async () => {
    var _playbackAuth$error;
    const deliveryStartAt = dayjs(episode.delivery_start_at);
    const now = dayjs();
    if (now.isAfter(deliveryStartAt) && (playbackAuth === null || playbackAuth === void 0 || (_playbackAuth$error = playbackAuth.error) === null || _playbackAuth$error === void 0 ? void 0 : _playbackAuth$error.code) == beforeDeliveryStartErrorCode && !isDeliveryStartChecked) {
      await state.resetAndUpdate();
      let force = true;
      await prepareToPlay(deviceInfo, force);
      setIsDeliveryStartChecked(true);
    }
  }, [episode, deviceInfo, state, playbackAuth, isDeliveryStartChecked]);
  useEffect(() => {
    var _playbackAuth$error2;
    if (episode && (playbackAuth === null || playbackAuth === void 0 || (_playbackAuth$error2 = playbackAuth.error) === null || _playbackAuth$error2 === void 0 ? void 0 : _playbackAuth$error2.code) == beforeDeliveryStartErrorCode) {
      clearInterval(deliveryCheckIntervalRef.current);
      deliveryCheckIntervalRef.current = setInterval(checkDeliveryStart, 15000);
    } else {
      clearInterval(deliveryCheckIntervalRef.current);
    }
    return () => {
      clearInterval(deliveryCheckIntervalRef.current);
    };
  }, [episode, playbackAuth]);

  // init
  useEffect(() => {
    const func = async () => {
      if (!userLoading && !watchLoading && !state.prepared && !state.overlay && episode) {
        await prepareToPlay(deviceInfo);
      }
    };
    func();
  }, [userLoading, watchLoading, state.prepared, state.overlay, episode, deviceInfo]);
  const entitleEndAt = useMemo(() => {
    if (isSVOD) {
      var _unSubscribedStatusDa;
      if (unSubscribedStatusData !== null && unSubscribedStatusData !== void 0 && (_unSubscribedStatusDa = unSubscribedStatusData.unSubscribedStatus) !== null && _unSubscribedStatusDa !== void 0 && _unSubscribedStatusDa.withdraw_at) {
        var _unSubscribedStatusDa2;
        const withdraw_at = unSubscribedStatusData === null || unSubscribedStatusData === void 0 || (_unSubscribedStatusDa2 = unSubscribedStatusData.unSubscribedStatus) === null || _unSubscribedStatusDa2 === void 0 ? void 0 : _unSubscribedStatusDa2.withdraw_at;
        const now = dayjs();
        if (now.isBefore(withdraw_at)) return dayjs(withdraw_at).format("YYYY/M/D H:mm");
      }
    } else {
      if (entitlements) {
        const entitlement = entitlements.find(entitlement => entitlement.end_at);
        if (entitlement) {
          return dayjs(entitlement.end_at).format("YYYY/M/D H:mm");
        }
      }
    }
    return null;
  }, [entitlements, unSubscribedStatusData, isSVOD, data, howtoPlay]);
  const isFullScreen = checkFullScreen();
  useEffect(() => {
    if (watchId && prevWatchId && watchId != prevWatchId && !isFullScreen) {
      window.location.reload();
    }
  }, [watchId, prevWatchId, isFullScreen]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(WatchMetaTags, {
      episode: episode
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsxs("section", {
        className: classnames(styles.playerContainer, {
          [styles.withChat]: chatDisplay
        }),
        children: [/*#__PURE__*/_jsxs("div", {
          className: classnames(styles.player, {
            [styles.withChat]: chatDisplay
          }),
          children: [(loading || userLoading) && /*#__PURE__*/_jsx(Loading, {
            fixed: true
          }), /*#__PURE__*/_jsx(StreaksPlayer, {
            onReady: handlePlayerReady,
            poster: episode === null || episode === void 0 ? void 0 : episode.thumbnailUrl,
            watch: watch,
            watchState: state,
            prevState: prevState,
            entitlements: entitlements,
            user: user,
            isChatAvailableMeta: isChatAvailableMeta,
            chatDisplay: chatDisplay,
            setChatDisplay: setChatDisplayState,
            isValidChatPeriod: isValidChatPeriod
          })]
        }), chatEnable && /*#__PURE__*/_jsx("div", {
          className: styles.chat,
          children: /*#__PURE__*/_jsx(ChatDisplay, {
            rooms: rooms,
            chatDisplay: chatDisplay,
            setChatDisplay: setChatDisplayState,
            setChatEnable: setChatEnable,
            metaId: episode.id,
            encodeEndDate: encodeEndDate,
            user: user
          })
        })]
      }), (!chatDisplay || !(isMobile || isTablet)) && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("section", {
          className: styles.detail,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.info,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.header,
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.first,
                children: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx("h1", {
                    className: styles.title,
                    children: episode.name
                  }), /*#__PURE__*/_jsx(WatchTags, {
                    meta: episode,
                    isBeforeChatEnd: isBeforeChatEnd,
                    isChatAvailableMeta: isChatAvailableMeta
                  })]
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.second,
                children: [/*#__PURE__*/_jsxs("div", {
                  className: classnames(styles.secondChild, styles.buttons),
                  children: [entitleEndAt && (isSVOD ? /*#__PURE__*/_jsxs("div", {
                    className: styles.entitleend,
                    children: [/*#__PURE__*/_jsx("div", {
                      children: "\u5951\u7D04\u7D42\u4E86\u65E5\u6642"
                    }), /*#__PURE__*/_jsx("div", {
                      children: entitleEndAt
                    })]
                  }) : /*#__PURE__*/_jsxs("div", {
                    className: styles.entitleend,
                    children: [/*#__PURE__*/_jsx("div", {
                      children: "\u8996\u8074\u53EF\u80FD\u671F\u9593"
                    }), /*#__PURE__*/_jsxs("div", {
                      children: [entitleEndAt, "\u307E\u3067"]
                    })]
                  })), /*#__PURE__*/_jsx(FavoriteButton, {
                    metaId: episode.id
                  }), /*#__PURE__*/_jsx(ShareButton, {
                    title: episode.name
                  })]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.secondChild,
                  children: isChatAvailableMeta && isValidChatPeriod && (!(playbackAuth !== null && playbackAuth !== void 0 && (_playbackAuth$error3 = playbackAuth.error) !== null && _playbackAuth$error3 !== void 0 && _playbackAuth$error3.code) || chatEnableErrorCodes.includes(playbackAuth === null || playbackAuth === void 0 || (_playbackAuth$error4 = playbackAuth.error) === null || _playbackAuth$error4 === void 0 ? void 0 : _playbackAuth$error4.code)) && !chatDisplay && /*#__PURE__*/_jsx(Button, {
                    className: styles.chatDisplayButton,
                    onClick: turnOnChatDisplay,
                    children: /*#__PURE__*/_jsx(ChatDisplayIcon, {})
                  })
                })]
              })]
            }), /*#__PURE__*/_jsxs(ExpandText, {
              className: styles.synopsis,
              children: [/*#__PURE__*/_jsx("p", {
                className: styles.description,
                children: episode.description
              }), /*#__PURE__*/_jsx("div", {
                children: episode.cast
              }), /*#__PURE__*/_jsx("div", {
                children: episode.staff
              }), /*#__PURE__*/_jsx("div", {
                children: episode.copyright
              })]
            }), isChatAvailableMeta && isBeforeChatEnd && /*#__PURE__*/_jsxs("div", {
              className: styles.chatNotice,
              children: ["\u30C1\u30E3\u30C3\u30C8\u6B04\u306FLIVE\u4E2D\u304A\u3088\u3073\u524D\u5F8C30\u5206\u306E\u307F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u30AC\u30A4\u30C9\u30E9\u30A4\u30F3\u3092\u3088\u304F\u8AAD\u3093\u3067\u3001\u697D\u3057\u304F\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Link, {
                href: "/static/legal/chat_guideline/",
                target: "_blank",
                rel: "noopener noreferrer",
                style: {
                  color: "#F7F989"
                },
                children: `${config.host.vod}/static/legal/chat_guideline/`
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), "\u203B\u7AEF\u672B\u306E\u30B9\u30DA\u30C3\u30AF\u3001\u30E1\u30E2\u30EA\u5BB9\u91CF\u306B\u3088\u308A\u30C1\u30E3\u30C3\u30C8\u3054\u5229\u7528\u4E2D\u306B\u52D5\u4F5C\u304C\u91CD\u304F\u306A\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002", /*#__PURE__*/_jsx("br", {}), "\u52D5\u4F5C\u304C\u91CD\u3044\u5834\u5408\u306F\u30D6\u30E9\u30A6\u30B6\u4EE5\u5916\u306E\u30A2\u30D7\u30EA\u3092\u9589\u3058\u308B\u3001\u30D6\u30E9\u30A6\u30B6\u306E\u4ED6\u306E\u30BF\u30D6\u3092\u9589\u3058\u308B\u7B49\u3054\u5BFE\u5FDC\u3044\u305F\u3060\u3044\u305F\u4E0A\u3067\u753B\u9762\u30EA\u30ED\u30FC\u30C9\u3092\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u4E0A\u8A18\u3067\u89E3\u6D88\u3057\u306A\u3044\u5834\u5408\u306F\u753B\u9762\u3092\u30EA\u30ED\u30FC\u30C9\u3044\u305F\u3060\u3044\u305F\u5F8C\u3001\u30C1\u30E3\u30C3\u30C8\u975E\u8868\u793A\u3067\u6620\u50CF\u3092\u304A\u697D\u3057\u307F\u304F\u3060\u3055\u3044\u3002"]
            })]
          })
        }), /*#__PURE__*/_jsxs("section", {
          className: styles.episodes,
          children: [isLinearAvailable && /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx(ChannelLinearEpisodesSlider, {
              header: {
                text: "配信予定",
                link: {
                  href: routes.channelDetail(episode.channel.id, "program")
                }
              },
              id: parseInt(episode.channel.id, 10),
              ignoreMetaId: ignoreMetaId
            })
          }), !isLinearAvailable && episode.tvShow && /*#__PURE__*/_jsx(TvShowEpisodesSlider, {
            header: {
              text: "エピソード一覧",
              link: {
                href: routes.title(episode.tvShow.id)
              }
            },
            id: parseInt(episode.tvShow.id, 10),
            ignoreMetaId: ignoreMetaId
          }), episode.recommend && /*#__PURE__*/_jsx(Palette, {
            id: episode.recommend
          })]
        }), /*#__PURE__*/_jsx("section", {
          children: /*#__PURE__*/_jsx(WatchRecommend, {})
        })]
      })]
    })]
  });
}